import { Divider, ListItemIcon, ListSubheader, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { useLanguage } from "./LanguageProvider";
import { LANGUAGE_NAMES } from "./languages";

/** Account-menu items; nothing when the build offers one language. */
export function LanguageMenuItems() {
  const { t } = useTranslation();
  const { language, languages, setLanguage } = useLanguage();
  if (languages.length < 2) return null;
  return [
    <Divider key="language-divider" />,
    <ListSubheader
      key="language-header"
      sx={{ lineHeight: "32px", bgcolor: "transparent" }}
    >
      {t("language.label")}
    </ListSubheader>,
    ...languages.map((lng) => (
      <MenuItem
        key={lng}
        lang={lng}
        selected={lng === language}
        onClick={() => void setLanguage(lng)}
        data-testid={`language-${lng}`}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          {lng === language && <CheckIcon fontSize="small" />}
        </ListItemIcon>
        {LANGUAGE_NAMES[lng]}
      </MenuItem>
    )),
  ];
}

export default LanguageMenuItems;
